'use client';

import React from 'react';

import { IBlock } from '@/lib/types';

import { BlockSkeleton } from './BlockSkeleton';

interface IBlockBatchSkeletonProps {
  blocks: IBlock[];
  firstBlockIndex?: number;
}

export const BlockBatchSkeleton = ({
  blocks,
  firstBlockIndex = 0,
}: IBlockBatchSkeletonProps): React.ReactElement => {
  return (
    <div
      aria-busy="true"
      data-testid="block-batch-skeleton"
      className="flex w-full flex-col gap-5 md:gap-[22px]"
    >
      {blocks.map((block: IBlock, index: number) => (
        <BlockSkeleton
          key={`${block.type}-${firstBlockIndex + index}`}
          block={block}
        />
      ))}
    </div>
  );
};
